import styled from "styled-components";
import { colorMixin, typographyMixin } from "../../../helpers";

export const Field = styled.div`
    > * + * {
        margin-top: 8px;
    }
`;

export const Label = styled.label`
    ${typographyMixin("label-x-small-medium")};
    color: ${colorMixin("text-primary-900")};
    display: flex;

    &[for] {
        cursor: pointer;
    }
`;

export const HelperText = styled.p<{ $error: boolean }>`
    ${typographyMixin("label-x-small-regular")};

    &,
    & strong,
    & a {
        color: ${({ $error }) => colorMixin($error ? "error-500" : "primary-700")};
    }

    a,
    strong {
        font-weight: 600;
    }

    a {
        cursor: pointer;
        text-decoration: underline;
    }

    strong {
        font-weight: 600;
    }
`;

export const TooltipTextWrapper = styled.span`
    white-space: break-spaces;
`;
